module.exports = __webpack_public_path__ + "static/media/recycle.26ea7d57.png";